import axios from "axios";
var Api = /** @class */ (function () {
    function Api(baseUri) {
        this.baseUri = baseUri;
        // Set default axios base URI
        axios.defaults.baseURL = this.baseUri;
    }
    /**
     * Runs an API request
     *
     * @param method   The method to use in the request
     * @param endpoint Where to request
     * @param data     POST data
     */
    Api.prototype.request = function (method, endpoint, data) {
        if (data === void 0) { data = {}; }
        return axios
            .request({
            method: method,
            url: endpoint,
            data: data,
            params: data
        })["catch"](function (error) {
            var status = error.response.status;
            switch (status) {
                case 404:
                    window.location.href = "/404";
                    break;
                case 403:
                    window.location.href = "/403";
                    break;
                case 400:
                    window.location.href = "/400";
                    break;
                default:
                    window.location.href = "/404";
                    break;
            }
        });
    };
    /**
     * Conforms a JSON response to a class
     *
     * @param mapClass The class to conform to
     * @param mapObj   The JSON response to map
     */
    Api.prototype.mapResponse = function (mapClass, mapObj) {
        // Loop through class and assign available values from map object
        Object.keys(mapClass).forEach(function (prop) {
            mapClass[prop] = mapObj[prop];
        });
        // Return the class with data
        return mapClass;
    };
    return Api;
}());
export { Api };
